import type {Component, Editor} from 'grapesjs';
import {
  alignSelectedText,
  setHorizontalAlignment,
  setVerticalAlignment,
  toggleBold,
  toggleItalic,
  toggleStrikethrough,
  toggleUnderline,
} from '@EmailMakerReact/lib/email-maker-component-style-library';
import type {OptionListDescriptor} from './option-list-control.types';

export const horizontalAlignDescriptor: OptionListDescriptor = {
  property: 'horizontal-align',
  titleKey: 'pmwjs_horizontal_alignment',
  list: [
    {
      value: 'left',
      name: 'pmwjs_left',
      classes: 'icon-h-align-left',
      callback: (_component: Component, editor: Editor): void => {
        setHorizontalAlignment(editor, 'left');
      },
    },
    {
      value: 'center',
      name: 'pmwjs_center',
      classes: 'icon-h-align-center',
      callback: (_component: Component, editor: Editor): void => {
        setHorizontalAlignment(editor, 'center');
      },
    },
    {
      value: 'right',
      name: 'pmwjs_right',
      classes: 'icon-h-align-right',
      callback: (_component: Component, editor: Editor): void => {
        setHorizontalAlignment(editor, 'right');
      },
    },
  ],
};

export const verticalAlignDescriptor: OptionListDescriptor = {
  property: 'vertical-align',
  titleKey: 'pmwjs_vertical_alignment',
  list: [
    {
      value: 'top',
      name: 'pmwjs_top',
      classes: 'icon-vertical-top',
      callback: (_component: Component, editor: Editor): void => {
        setVerticalAlignment(editor, 'top');
      },
    },
    {
      value: 'middle',
      name: 'pmwjs_middle',
      classes: 'icon-v-align-center',
      callback: (_component: Component, editor: Editor): void => {
        setVerticalAlignment(editor, 'middle');
      },
    },
    {
      value: 'bottom',
      name: 'pmwjs_bottom',
      classes: 'icon-vertical-bottom',
      callback: (_component: Component, editor: Editor): void => {
        setVerticalAlignment(editor, 'bottom');
      },
    },
  ],
};

export const textAlignDescriptor: OptionListDescriptor = {
  property: 'text-align',
  titleKey: 'pmwjs_alignment',
  list: [
    {
      value: 'left',
      name: 'pmwjs_left',
      classes: 'icon-align-left',
      callback: (_component: Component, editor: Editor): void => {
        alignSelectedText(editor, 'left');
      },
    },
    {
      value: 'center',
      name: 'pmwjs_center',
      classes: 'icon-align-center',
      callback: (_component: Component, editor: Editor): void => {
        alignSelectedText(editor, 'center');
      },
    },
    {
      value: 'right',
      name: 'pmwjs_right',
      classes: 'icon-align-right',
      callback: (_component: Component, editor: Editor): void => {
        alignSelectedText(editor, 'right');
      },
    },
    {
      value: 'justify',
      name: 'pmwjs_justify',
      classes: 'icon-align-block',
      callback: (_component: Component, editor: Editor): void => {
        alignSelectedText(editor, 'justify');
      },
    },
  ],
};

export const textAlignSimpleDescriptor: OptionListDescriptor = {
  property: 'text-align',
  titleKey: 'pmwjs_alignment',
  list: [
    {
      value: 'left',
      name: 'pmwjs_left',
      classes: 'icon-h-align-left',
      callback: (_component: Component, editor: Editor): void => {
        alignSelectedText(editor, 'left');
      },
    },
    {
      value: 'center',
      name: 'pmwjs_center',
      classes: 'icon-h-align-center',
      callback: (_component: Component, editor: Editor): void => {
        alignSelectedText(editor, 'center');
      },
    },
    {
      value: 'right',
      name: 'pmwjs_right',
      classes: 'icon-h-align-right',
      callback: (_component: Component, editor: Editor): void => {
        alignSelectedText(editor, 'right');
      },
    },
  ],
};

export const fontStyleDescriptor: OptionListDescriptor = {
  property: 'pmw-font-style',
  titleKey: 'pmwjs_style',
  toggleable: true,
  list: [
    {
      property: 'font-weight',
      value: 'bold',
      name: 'pmwjs_bold',
      classes: 'icon-bold',
      callback: (_component: Component, editor: Editor): void => {
        toggleBold(editor);
      },
    },
    {
      property: 'font-style',
      value: 'italic',
      name: 'pmwjs_italic',
      classes: 'icon-italic',
      callback: (_component: Component, editor: Editor): void => {
        toggleItalic(editor);
      },
    },
    {
      property: 'text-decoration',
      value: 'line-through',
      name: 'pmwjs_strikethrough',
      classes: 'icon-strike-through',
      callback: (_component: Component, editor: Editor): void => {
        toggleStrikethrough(editor);
      },
    },
    {
      property: 'text-decoration',
      value: 'underline',
      name: 'pmwjs_underline',
      classes: 'icon-underline',
      callback: (_component: Component, editor: Editor): void => {
        toggleUnderline(editor);
      },
    },
  ],
};
